import { ArrowUpRight } from "lucide-react";
import { CopyButton } from "@/components/copy-button";
import { TEMPLATE_REPO } from "@/lib/links";

const CLONE = "git clone git@github.com:qureai/fastapi-vite-startecode-temlate.git myapp";

/**
 * The starter template, as step zero of the gallery.
 *
 * Deliberately *not* shaped like a block card. A block is installed into an
 * app; the template **is** the app. Giving it the same card would imply you
 * add it the same way, which is the one thing about this system that is
 * important not to get wrong — so it gets a wider, quieter treatment and its
 * own neutral artwork rather than a category accent.
 */
export function TemplateCard() {
  return (
    <section className="overflow-hidden rounded-xl border border-ink-700 bg-ink-900">
      <div className="grid gap-0 sm:grid-cols-[1fr_15rem]">
        <div className="flex flex-col gap-4 p-6">
          <div className="flex items-center gap-2">
            <span className="rounded-full border border-ink-400/40 px-2 py-0.5 text-[0.6875rem] font-medium text-ink-200">
              Start here
            </span>
            <span className="text-xs text-ink-400">then add the blocks below</span>
          </div>

          <div className="space-y-2">
            <h2 className="text-xl font-medium tracking-tight text-ink-50">
              FastAPI + Vite starter template
            </h2>
            <p className="max-w-xl text-sm leading-relaxed text-ink-400">
              The app every block installs into. Layered FastAPI backend, React SPA served
              by the same process, Postgres, Docker for dev and prod — and a worked feature
              wired through every layer to copy from.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <code className="min-w-0 flex-1 truncate rounded-lg border border-ink-700 bg-ink-800 px-3 py-2 text-xs text-ink-200">
              {CLONE}
            </code>
            <CopyButton value={CLONE} />
            <a
              href={TEMPLATE_REPO}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-1 rounded-lg border border-ink-700 px-3 py-2 text-xs text-ink-200 transition-colors hover:border-ink-400 hover:text-ink-50"
            >
              Repo
              <ArrowUpRight size={13} />
            </a>
          </div>
        </div>

        <div className="order-first h-40 overflow-hidden bg-ink-950 sm:order-last sm:h-auto">
          <img
            src="/starter-template.png"
            alt=""
            className="size-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}
